import { generateFaqQuestion } from 'src/libs/faq-lib/data/generateFaqQuestion'
import { FAQTopic, FAQTopicKey } from 'src/libs/faq-lib/faq.model'

export const faqGeneralData: FAQTopic = {
    topicKey: FAQTopicKey.GENERAL,
    headlineTranslationKey: 'faq-general-topic-headline',
    sublineTranslationKey: 'faq-general-topic-subline',
    categories: [
        {
            categoryKey: 'faq-general-general-questions',
            categoryTranslationKey: 'faq-general-questions',
            questions: [
                generateFaqQuestion('faq-can-i-use-traigo-for-free'),
                generateFaqQuestion('faq-is-traigo-part-of-vtg'),
                generateFaqQuestion(
                    'faq-i-am-not-a-customer-of-vtg-rail-europe'
                ),
                generateFaqQuestion('faq-can-i-use-traigo-for-non-vtg-wagons'),
                generateFaqQuestion('faq-how-can-i-learn-more'),
                generateFaqQuestion('faq-what-features-has-traigo'),
                generateFaqQuestion('faq-processing-traigo-data'),
                generateFaqQuestion('faq-i-dont-see-all-my-contracts'),
                generateFaqQuestion('faq-how-does-wagon-tracking-work'),
                generateFaqQuestion('faq-where-are-wagon-details'),
                generateFaqQuestion('faq-connector-doesnt-work'),
            ],
        },
        {
            categoryKey: 'faq-general-access',
            categoryTranslationKey: 'faq-general-access',
            questions: [
                generateFaqQuestion('faq-i-am-traigo-admin'),
                generateFaqQuestion('faq-how-can-i-create-a-user'),
            ],
        },
        {
            categoryKey: 'faq-general-support',
            categoryTranslationKey: 'faq-general-support',
            questions: [generateFaqQuestion('faq-i-cant-login')],
        },
    ],
}
